<template>
	<form class="guest_data">
		<div class="title" v-if="extended_checkin != 1">{{ getTranslation('GUEST') }} #{{guest_number}}</div>
		<div class="row" v-if="extended_checkin == 1 || onlyPhoto == 1">
			<label :for="'photo_' + guest_number">Foto identificativa</label>
			<input type="file" :id="'photo_' + guest_number" accept="image/*" capture="environment" @change="onPhotoSelected" />
		</div>
		<div class="row">
			<label :for="'surname_' + guest_number"><span class="error"></span>{{ getTranslation('SURNAME') }}</label>
			<input type="text" :id="'surname_' + guest_number" v-model="surname" :disabled="checkSurname()" autocomplete="family-name"/>
		</div>
		<div class="row">
			<label :for="'name_' + guest_number"><span class="error"></span>{{ getTranslation('NAME') }}</label>
			<input type="text" :id="'name_' + guest_number" v-model="name" :disabled="checkName()" autocomplete="given-name"/>
		</div>
		<div class="row" v-if="onlyPhoto == 0">
			<label :for="'gender_' + guest_number">{{ getTranslation('SEX') }}</label>
			<select :id="'gender_' + guest_number" v-model="gender">
				<option value="M">M</option>
				<option value="F">F</option>
			</select>
		</div>
		<div class="row" v-if="onlyPhoto == 0">
			<label :for="'birthdate_' + guest_number"><span class="error"></span>{{ getTranslation('BIRTHDATE') }}</label>
			<input type="date" :id="'birthdate_' + guest_number" v-model="birthdate" :disabled="checkBirthdate()"/>
		</div>
		<div class="row" v-if="onlyPhoto == 0">
			<label :for="'birthstate_' + guest_number">{{ getTranslation('STATEBIRTH') }}</label>
			<select :id="'birthstate_' + guest_number" v-model="birthstate" autocomplete="country">
				<option v-for="country in birthCountries" v-bind:key="country.ALPHA2CODE" v-bind:value="country.ALPHA2CODE">{{ country.DESCRIPTION }}</option>
			</select>
		</div>
		<div class="row" v-if="onlyPhoto == 0">
			<label :for="'birthcity_' + guest_number"><span class="error"></span>{{ getTranslation('CITYBIRTH') }}</label>
			<input type="text" :id="'birthcity_' + guest_number" v-model="birthcity" :list="'birthcities_' + guest_number" autocomplete="nope" />
			<datalist :id="'birthcities_' + guest_number">
				<option v-for="(city, index) in birthcities" :key="index" :value="city"></option>
			</datalist>
		</div>
		<div class="row" v-if="onlyPhoto == 0">
			<label :for="'citizenship_' + guest_number">{{ getTranslation('STATECITIZEN') }}</label>
			<select :id="'citizenship_' + guest_number" v-model="citizenship" autocomplete="country">
				<option v-for="country in countries" v-bind:key="country.ALPHA2CODE" v-bind:value="country.ALPHA2CODE">{{ country.DESCRIPTION }}</option>
			</select>
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'state_' + guest_number">{{ getTranslation('STATERES') }}</label>
			<select :id="'state_' + guest_number" v-model="state" autocomplete="country">
				<option v-for="country in countries" v-bind:key="country.ALPHA2CODE" v-bind:value="country.ALPHA2CODE">{{ country.DESCRIPTION }}</option>
			</select>
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'city_' + guest_number"><span class="error"></span>{{ getTranslation('CITY') }}</label>
			<input type="text" :id="'city_' + guest_number" v-model="city" :list="'cities_' + guest_number" autocomplete="nope" />
			<datalist :id="'cities_' + guest_number">
				<option v-for="(city, index) in cities" :key="index" :value="city"></option>
			</datalist>
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'address_' + guest_number"><span class="error"></span>{{ getTranslation('ADDRESS') }}</label>
			<input type="text" :id="'address_' + guest_number" v-model="address" />
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'identitydocument_' + guest_number">{{ getTranslation('DOCID') }}</label>
			<select :id="'identitydocument_' + guest_number" v-model="identitydocument">
				<option v-for="identity_document in identity_documents" v-bind:key="identity_document.ID" v-bind:value="identity_document.ID">{{ identity_document.DESCRIPTION }}</option>
			</select>
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'identitydocumentnumber_' + guest_number"><span class="error"></span>{{ getTranslation('DOCNR') }}</label>
			<input type="text" :id="'identitydocumentnumber_' + guest_number" v-model="identitydocumentnumber" />
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :for="'identitydocumentstate_' + guest_number">{{ getTranslation('STATEDOC') }}</label>
			<select :id="'identitydocumentstate_' + guest_number" v-model="identitydocumentstate" autocomplete="country">
				<option v-for="country in countries" v-bind:key="country.ALPHA2CODE" v-bind:value="country.ALPHA2CODE">{{ country.DESCRIPTION }}</option>
			</select>
		</div>
		<div class="row" v-if="guest_number == 1 && onlyPhoto == 0">
			<label :id="'identitydocumentcity_' + guest_number"><span class="error"></span>{{ getTranslation('IDCITYDOCUMENT') }}</label>
			<input type="text" :id="'identitydocumentcity_' + guest_number" v-model="identitydocumentcity" :list="'documentcities_' + guest_number" autocomplete="nope" />
			<datalist :id="'documentcities_' + guest_number">
				<option v-for="(city, index) in documentcities" :key="index" :value="city"></option>
			</datalist>
		</div>
		<div class="row" v-if="extended_checkin == 1 || onlyPhoto == 1">
			<label :for="'document1_photo_' + guest_number">{{ getTranslation('DOCUMENT_FRONT') }}</label>
			<input type="file" multiple :id="'document1_photo_' + guest_number" accept="image/*" capture="environment" @change="onPhotoSelected2" />
		</div>
		<div class="row" v-if="extended_checkin == 1 || onlyPhoto == 1">
			<label :for="'document2_photo_' + guest_number">{{ getTranslation('DOCUMENT_BACK') }}</label>
			<input type="file" multiple :id="'document2_photo_' + guest_number" accept="image/*" capture="environment" @change="onPhotoSelected3" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'matricola_' + guest_number"><span class="error"></span>Matricola</label>
			<input type="text" :id="'matricola_' + guest_number" v-model="matricola" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'annoDiCorso_' + guest_number"><span class="error"></span>{{ getTranslation('COURSE_YEAR') }}</label>
			<input type="text" :id="'annoDiCorso_' + guest_number" v-model="annoDiCorso" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'corso_' + guest_number"><span class="error"></span>{{ getTranslation('DEGREE_COURSE') }}</label>
			<input type="text" :id="'corso_' + guest_number" v-model="corso" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'ateneo_' + guest_number"><span class="error"></span>{{ getTranslation('UNIVERSITY_SCHOOL') }}</label>
			<input type="text" :id="'ateneo_' + guest_number" v-model="ateneo" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'emailFatture_' + guest_number"><span class="error"></span>{{ getTranslation('INVOICE_EMAIL') }}</label>
			<input type="text" :id="'emailFatture_' + guest_number" v-model="emailFatture" />
		</div>
		<div class="row" v-if="extended_checkin == 1 && onlyPhoto == 0">
			<label :for="'telefono_' + guest_number"><span class="error"></span>{{ getTranslation('PHONE') }}</label>
			<input type="text" :id="'telefono_' + guest_number" v-model="telefono" />
		</div>
	</form>
</template>

<script>
	import jQuery from 'jquery'
	let $ = jQuery

	export default {
		name: 'GuestData',
		props: ['guest_number'],
		data() {
			return {
				surname: '',
				name: '',
				gender: 'M',
				birthdate: '',
				birthstate: 'IT',
				birthcity: '',
				citizenship: 'IT',
				state: 'IT',
				city: '',
				address: '',
				identitydocument: 10590,
				identitydocumentnumber: '',
				identitydocumentstate: 'IT',
				identitydocumentcity: '',
				matricola: '',
				annoDiCorso: '',
				corso: '',
				ateneo: '',
				emailFatture: '',
				telefono: '',
				photo: null,
				photo2: null,
				photo3: null,
				onlyPhoto: 0
			}
		},
		computed: {
			countries: function() {
				return this.$store.state.countries;
			},
			birthCountries: function() {
				return this.$store.state.birthCountries;
			},
			birthcities: function() {
				if(this.birthstate == 'IT') {
					return this.$store.state.cities;
				} else {
					return [];
				}
			},
			cities: function() {
				if(this.state == 'IT') {
					return this.$store.state.cities;
				} else {
					return [];
				}
			},
			documentcities: function() {
				if(this.identitydocumentstate == 'IT') {
					return this.$store.state.cities;
				} else {
					return [];
				}
			},
			identity_documents: function() {
				return this.$store.state.identity_documents;
			},
			extended_checkin: function() {
				return this.$store.state.company_info.extended;
			}
		},
		methods: {
			checkSurname: function() {
				let urlParams = new URLSearchParams(window.location.search);
				if(urlParams.get('surname') != null){
					return true
				}else{
					return false
				}
			},
			checkName: function() {
				let urlParams = new URLSearchParams(window.location.search);
				if(urlParams.get('name') != null){
					return true
				}else{
					return false
				}
			},
			checkBirthdate: function() {
				let urlParams = new URLSearchParams(window.location.search);
				if(urlParams.get('year') != null && urlParams.get('month') && urlParams.get('day')){
					return true
				}else{
					return false
				}
			},
			getTranslation: function(key) {
				return this.$store.getters.get_translation(key);
			},
			onPhotoSelected(event) {
				const file = event.target.files[0];
				if (file) {
					this.photo = file;
				}else{
					this.photo = null;
				}
			},
			onPhotoSelected2(event) {
				const file = event.target.files[0];
				if (file) {
					this.photo2 = file;
				}else{
					this.photo2 = null;
				}
			},
			onPhotoSelected3(event) {
				const file = event.target.files[0];
				if (file) {
					this.photo3 = file;
				}else{
					this.photo3 = null;
				}
			},
			checkData: function() {
				let all_ok = true;

				if(this.surname == '') {
					$('#surname_'+this.guest_number).addClass('invalid_input');
					$('#surname_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
					all_ok = false;
				}

				if(this.name == '') {
					$('#name_'+this.guest_number).addClass('invalid_input');
					$('#name_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
					all_ok = false;
				}

				if(this.onlyPhoto == 0) {
					if(this.birthdate == '') {
						$('#birthdate_'+this.guest_number).addClass('invalid_input');
						$('#birthdate_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
						all_ok = false;
					}
	
					if(this.birthcity == '') {
						$('#birthcity_'+this.guest_number).addClass('invalid_input');
						$('#birthcity_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
						all_ok = false;
					} else if(this.birthstate == 'IT') {
						if(!this.birthcities.includes(this.birthcity)) {
							$('#birthcity_'+this.guest_number).addClass('invalid_input');
							$('#birthcity_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
					}
	
					if(this.guest_number == 1) {
						if(this.city == '') {
							$('#city_'+this.guest_number).addClass('invalid_input');
							$('#city_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						} else if(this.birthstate == 'IT') {
							if(!this.cities.includes(this.city)) {
								$('#city_'+this.guest_number).addClass('invalid_input');
								$('#city_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
								all_ok = false;
							}
						}
	
						if(this.identitydocumentnumber == '') {
							$('#identitydocumentnumber_'+this.guest_number).addClass('invalid_input');
							$('#identitydocumentnumber_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.identitydocumentcity == '') {
							$('#identitydocumentcity_'+this.guest_number).addClass('invalid_input');
							$('#identitydocumentcity_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						} else if(this.identitydocumentstate == 'IT') {
							if(!this.documentcities.includes(this.identitydocumentcity)) {
								$('#identitydocumentcity_'+this.guest_number).addClass('invalid_input');
								$('#identitydocumentcity_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
								all_ok = false;
							}
						}
					}
				}

				if(this.extended_checkin == 1) {
					if(this.photo == null) {
						$('#photo_'+this.guest_number).addClass('invalid_input');
						$('#photo_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
						all_ok = false;
					}

					if(this.photo2 == null) {
						$('#document1_photo_'+this.guest_number).addClass('invalid_input');
						$('#dosument1_photo_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
						all_ok = false;
					}

					if(this.photo3 == null) {
						$('#document2_photo_'+this.guest_number).addClass('invalid_input');
						$('#dosument2_photo_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
						all_ok = false;
					}

					if(this.onlyPhoto == 0){
						if(this.matricola == '') {
							$('#matricola_'+this.guest_number).addClass('invalid_input');
							$('#matricola_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.annoDiCorso == '') {
							$('#annoDiCorso_'+this.guest_number).addClass('invalid_input');
							$('#annoDiCorso_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.corso == '') {
							$('#corso_'+this.guest_number).addClass('invalid_input');
							$('#corso_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.ateneo == '') {
							$('#ateneo_'+this.guest_number).addClass('invalid_input');
							$('#ateneo_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.emailFatture == '') {
							$('#emailFatture_'+this.guest_number).addClass('invalid_input');
							$('#emailFatture_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
	
						if(this.telefono == '') {
							$('#telefono_'+this.guest_number).addClass('invalid_input');
							$('#telefono_'+this.guest_number).siblings('label').find('.error').html('<i class="fas fa-exclamation-triangle"></i>');
							all_ok = false;
						}
					}
				}

				return all_ok;
			},
			getData: function() {
				
				if(this.guest_number == 1) {

					return {
						guest_number: this.guest_number,
						surname: this.surname,
						name: this.name,
						gender: this.gender,
						birthdate: this.birthdate,
						birthstate: this.birthstate,
						birthcity: this.birthcity,
						citizenship: this.citizenship,
						state: this.state,
						city: this.city,
						address: this.address,
						identitydocument: this.identitydocument,
						identitydocumentnumber: this.identitydocumentnumber,
						identitydocumentstate: this.identitydocumentstate,
						identitydocumentcity: this.identitydocumentcity,
						matricola: this.matricola,
						annoDiCorso: this.annoDiCorso,
						corso: this.corso,
						ateneo: this.ateneo,
						emailFatture: this.emailFatture, 
						telefono: this.telefono,
						photo: this.photo,
						photo2: this.photo2,
						photo3: this.photo3,
						onlyphoto: this.onlyPhoto
					};
				} else {
					return {
						guest_number: this.guest_number,
						surname: this.surname,
						name: this.name,
						gender: this.gender,
						birthdate: this.birthdate,
						birthstate: this.birthstate,
						birthcity: this.birthcity,
						citizenship: this.citizenship
					};
				}
			}
		},
		mounted:function()  {
			let urlParams = new URLSearchParams(window.location.search);
			if(urlParams.get('surname') != null){
				this.surname = urlParams.get('surname');
			}
			if(urlParams.get('name') != null){
				this.name = urlParams.get('name');
			}
			if(urlParams.get('year') != null && urlParams.get('month') != null && urlParams.get('day') != null){
				let year = urlParams.get('year');
				let month = urlParams.get('month');
				let day = urlParams.get('day');
				this.birthdate = year +'-'+ month +'-'+ day
			}
			if(urlParams.get('images') != null){
				this.onlyPhoto = urlParams.get('images');
			}
		}
	}
</script>

<style type="text/css" scoped>
	.guest_data {
		display: flex;
		flex-direction: column;
		box-shadow: 0 1px 9px rgba(0,0,0,.16);
		padding: 15px;
		border-radius: 6px;
		border-left: 5px solid var(--mainColor);
		margin-top: 30px;
	}

	.title {
		font-size: 18px;
		font-weight: 700;
		margin-bottom: 5px;
	}

	.row {
		margin-top: 10px;
		display: flex;
		align-items: center;
	}

	.row label {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		width: 200px;
		text-align: right;
		padding-right: 15px;
		position: relative;
	}

	.row label .error {
		color: #802;
		font-size: 12px;
		margin-right: 5px;
	}

	.row input[type="text"],
	.row input[type="date"] {
		flex: 1;
		border: none;
		outline: none!important;
		box-shadow: 0 3px 6px rgba(0,0,0,.16);
		border-radius: 3px;
		padding: 6px 8px;
		resize: none;
		font-family: Montserrat,sans-serif;
	}

	.row input.invalid_input {
		box-shadow: 1px 1px 6px #88002288 !important;
	}

	.row select {
		flex: 1;
		border: none;
		box-shadow: 0 3px 6px rgba(0,0,0,.16);
		padding: 6px 5px;
		border-radius: 3px;
		font-family: Montserrat,sans-serif;
		outline: none!important;
		max-width: 365px;
	}

	@media only screen and (max-width: 799px) {
		.row {
			flex-direction: column;
			align-items: flex-start;
		}

		.row label {
			text-align: left;
			justify-content: flex-start;
			width: 100%;
		}

		.row input[type="text"],
		.row input[type="date"] {
			width: 100%;
		}

		.row select {
			max-width: 100%;
			width: 100%;
		}
	}
</style>